import React from 'react';

import styles from './style.css';

export function DropdownOption({
    option,
    isSelected,
    isHighlighted,
    onSelect,
    id,
    renderOption,
}) {
    return (
        <div
            id={id}
            role="option"
            aria-selected={isSelected}
            className={[
                styles.option,
                isSelected && styles.selectedOption,
                isHighlighted && styles.highlightedOption,
            ].filter(Boolean).join(' ')}
            onClick={() => onSelect(option.value)}
        >
            {renderOption ? renderOption(option) : option.label}
        </div>
    );
}
